export default "__VITE_PUBLIC_ASSET__b36b8828__"